import { Icons } from "@/components/elements/Icon/types";
import { DeliveryStage } from "@/types/api/deliveries";

export enum DeliveryEventTransKey {
  RECEIVED = "delivery_event_received",
  CREATED = "delivery_event_created",
  READY_FOR_SHIPPING = "delivery_event_ready_for_shipping",
  SHIPPED = "delivery_event_shipped",
  DELIVERED = "delivery_event_delivered",
  CANCELLED = "delivery_event_cancelled",
}

export enum DeliveryStatusTransKey {
  PROCESSING = "overview_recent_processing_delivery",
  EXPECTED_DELIVERY_DATE = "overview_recent_expected_delivery_date",
  DELIVERED = "overview_recent_delivery_delivered",
  CANCELLED = "overview_recent_delivery_cancelled",
  UNKNOWN = "unknown",
}

export interface DeliveryStatusInfo {
  statusKey: DeliveryStatusTransKey;
  eventKey: DeliveryEventTransKey;
  icon: Icons;
}

export const UNKNOWN_DELIVERY_STATUS_INFO: DeliveryStatusInfo = {
  statusKey: DeliveryStatusTransKey.UNKNOWN,
  eventKey: DeliveryEventTransKey.CANCELLED,
  icon: "info",
};

export const DELIVERY_STATUSES_INFO: Readonly<
  Record<DeliveryStage, DeliveryStatusInfo>
> = {
  [DeliveryStage.NOT_BOOKED]: {
    statusKey: DeliveryStatusTransKey.PROCESSING,
    icon: "calendar",
    eventKey: DeliveryEventTransKey.RECEIVED,
  },
  [DeliveryStage.BOOKED]: {
    statusKey: DeliveryStatusTransKey.EXPECTED_DELIVERY_DATE,
    icon: "truck",
    eventKey: DeliveryEventTransKey.CREATED,
  },
  [DeliveryStage.EN_ROUTE]: {
    statusKey: DeliveryStatusTransKey.EXPECTED_DELIVERY_DATE,
    icon: "truck",
    eventKey: DeliveryEventTransKey.SHIPPED,
  },
  [DeliveryStage.DELIVERED]: {
    statusKey: DeliveryStatusTransKey.DELIVERED,
    icon: "delivered",
    eventKey: DeliveryEventTransKey.DELIVERED,
  },
  [DeliveryStage.FAILED]: {
    statusKey: DeliveryStatusTransKey.CANCELLED,
    icon: "exclamation",
    eventKey: DeliveryEventTransKey.CANCELLED,
  },
  [DeliveryStage.UNKNOWN]: UNKNOWN_DELIVERY_STATUS_INFO,
};

export const DELIVERY_STATUSES_ORDERED = [
  DeliveryStage.NOT_BOOKED,
  DeliveryStage.BOOKED,
  DeliveryStage.EN_ROUTE,
  DeliveryStage.DELIVERED,
];
